// Source / CS:S movement values. See docs/MOVEMENT.md.
// All simulation code uses Source units and Source axes: X forward (yaw 0), Y left, Z up.

export const TICKRATE = 100;
export const DT = 1 / TICKRATE;

/** Movement cvars. `airaccelerate` is the only one the player changes (settings). */
export interface Cvars {
  gravity: number;
  maxspeed: number;
  accelerate: number;
  airaccelerate: number;
  friction: number;
  stopspeed: number;
  jumpVelocity: number;
  stepsize: number;
  maxvelocity: number;
  /** Air wishspeed cap. Only caps `addspeed`; `accelspeed` uses the uncapped wishspeed. */
  aircap: number;
  duckmul: number;
  /** cl_forwardspeed / cl_sidespeed */
  forwardspeed: number;
  /**
   * Not CS:S: after a fall, landing on a downhill slope keeps you sliding (no friction, no jump,
   * gravity speeds you up) until the ground flattens out. Off = exact CS:S.
   */
  slopeSlide: boolean;
}

export function defaultCvars(): Cvars {
  return {
    gravity: 800,
    maxspeed: 250,
    accelerate: 5,
    airaccelerate: 100,
    friction: 4,
    stopspeed: 75,
    jumpVelocity: 301.993377,
    stepsize: 18,
    maxvelocity: 3500,
    aircap: 30,
    duckmul: 0.34,
    forwardspeed: 450,
    slopeSlide: true,
  };
}

export const AIRACCEL_PRESETS = [10, 100, 150, 1337] as const;

// Player hull. Origin at the feet.
export const HULL_HALF_WIDTH = 16;
export const HULL_HEIGHT_STAND = 72;
export const HULL_HEIGHT_DUCK = 54;
export const EYE_STAND = 64;
export const EYE_DUCK = 46;

export const NON_JUMP_VELOCITY = 140;
export const DIST_EPSILON = 0.03125;

// Game rules (not movement).
export const PRESPEED_CAP = 290;
/** Max ticks (0.1 s) the player may stay on one bhop block. */
export const BLOCK_TICKS = 10;
/** Falling below this height sends the player back to the stage checkpoint. */
export const FAIL_Z = -200;
